import BaseApiClient from './BaseApiClient';

/**
 * @class JwtBaseClient
 * @extends BaseApiClient
 * @description Client used to interface with services using JWT authorization
 */
class JwtBaseClient extends BaseApiClient {
  constructor(baseUri, pathToApiErrors, additionalHeaders = {}) {
    const headers = {
      'Content-Type': 'application/json',
      ...additionalHeaders,
    };

    super(baseUri, headers, pathToApiErrors);
  }
}

export default JwtBaseClient;
